import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchNote } from '../../services/NotesService';
import { Note, PatchNoteRequest } from '../../types/Notes';

type Result = UseMutationResult<Note, Error, PatchNoteRequest>;

function usePatchNote(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchNote, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['notes'] });
      queryClient.invalidateQueries({ queryKey: ['notes-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchNote;
